import styles from "./index.module.scss"



const HeaderContent = () => {
    return (
        <article className={styles.content}>
            <h2 className={styles.title + " fw-900"}>
                فروش
                <span className="text-primary"> اقسـاطــی </span>

                <div className={styles.caption__title + " flex flex-column align-i-center"}>
                    <p className="text-primary">
                        بدون سود
                    </p>

                    <svg width="160" height="108" viewBox="0 0 170 118" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M151.653 22.3987C131.57 29.1923 108.825 43.3832 93.8986 62.1579C83.7886 74.8803 77.253 89.7026 77.3452 105.726C77.3552 107.106 78.482 108.214 79.8625 108.204C81.2493 108.202 82.3572 107.075 82.3472 105.695C82.2544 90.8162 88.4176 77.0921 97.8121 65.2822C112.147 47.2554 133.977 33.6502 153.254 27.148C154.56 26.6964 155.265 25.2778 154.828 23.9728C154.376 22.6663 152.958 21.9612 151.653 22.3987Z" fill="#333C46" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M48.7803 27.9433C65.4999 37.8491 72.4653 51.2577 75.8366 59.4934C81.6408 73.6728 85.333 89.9173 81.8813 105.565C81.5819 106.912 80.2477 107.759 78.9 107.46C77.5445 107.167 76.6977 105.832 76.9971 104.485C80.2093 89.9569 75.8584 72.2773 71.3491 61.8327C68.2483 54.6505 63.4999 42 46.2185 32.251C45.0358 31.5353 44.6441 30.0004 45.3457 28.8162C46.0614 27.6335 47.5961 27.2417 48.7803 27.9433Z" fill="#333C46" />
                    </svg>
                </div>

                <span className="mr-sm">کـابیـنت و کـمد</span>
            </h2>

            <p className={styles.caption__header + " fw-500"}>
                بدون نیاز به ضامن
            </p>

            <p className={styles.description__header + " fw-500"}>
                با طرح خرید اقساطی سلا‌م‌ساختمان، تا 50 درصد از مبلغ ساخت کابینت را در اقساط 6 ماهه پرداخت کنید و صاحب آشپرخانه رویایی‌تان شوید.
            </p>
        </article>
    )
}

export default HeaderContent